import { Injectable } from '@angular/core';
import { IAdapter } from 'src/app/models/adapter';
import { Colour } from 'src/app/models/domain';
import { YPMMULTICOLOURVCDSYPMCOLOURVType } from 'src/generated-clients/multicolour';

@Injectable({
  providedIn: 'root',
})
export class ColourAdapter implements IAdapter<Colour, YPMMULTICOLOURVCDSYPMCOLOURVType> {
  public adaptToDomain(item: YPMMULTICOLOURVCDSYPMCOLOURVType): Colour {
    return new Colour(
      item.colourId ?? '',
      item.colourTypeDescription ?? '',
      item.colourDescription ?? '',
      item.colourType ?? '',
      item.red ?? '',
      item.green ?? '',
      item.blue ?? ''
    );
  }
}
